/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

//import { RatingComponent, SwatchComponent } from '@msdyn365-commerce/components';
import { IAny, ICoreContext, IGeneric } from '@msdyn365-commerce/core';
import { RefinerType } from '@msdyn365-commerce/retail-proxy';
//import { checkIfShouldDisplayAsSwatch, DimensionTypes, IDimensionsApp, StringExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { /*format,*/ getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ILobasTableRefineItemCommonProps } from './lobas-refine-item.props.common';
import { ILobasTableRefineItemToggleNotification } from './lobas-refine-item-toggle-notification';
import { ILobasTableRefinerHierarchy, ILobasTableRefinerValue } from './lobas-table';

/**
 * RefineItem properties.
 */
export interface ILobasTableRefineItemProps {
    parentTableRefinerHierarchy: ILobasTableRefinerHierarchy;
    tableRefinerValue: ILobasTableRefinerValue;
    selectedRefinementCriterion: ILobasTableRefinerValue | undefined;
    selectedRefinerValues?: ILobasTableRefinerValue[];
    refineItemCommonProps: ILobasTableRefineItemCommonProps;
    isDisabled: boolean;
    context: ICoreContext<IGeneric<IAny>>;
    moduleId: string;
    moduleTypeName: string;
    index?: number;
    tableCountAriaLabel?: string;
    singleTableCountAriaLabel?: string;
    isMobileView?: boolean;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onToggle(notfication: Readonly<ILobasTableRefineItemToggleNotification>): void;
    urlBuilder(refiner: ILobasTableRefineItemToggleNotification): string;
}

/**
 * Refine item state.
 */
export interface ILobasTableRefineItemState extends React.ComponentState {
    isChecked: boolean;
    renderingError?: object;
}

/**
 * Single-select and multi-select refine item component (controlled by RefineSubmenu).
 */
export default class LobasTableRefineItem extends React.Component<ILobasTableRefineItemProps, ILobasTableRefineItemState> {
    private readonly anchorType: React.RefObject<HTMLAnchorElement>;

    private readonly payLoad: IPayLoad;

    public constructor(props: ILobasTableRefineItemProps) {
        super(props);
        this._onClick = this._onClick.bind(this);
        this.state = {
            isChecked: !!this.props.selectedRefinementCriterion
        };
        this.anchorType = React.createRef();
        this.payLoad = getPayloadObject('click', this.props.telemetryContent!, '');
    }

    public shouldComponentUpdate(nextProps: ILobasTableRefineItemProps, nextState: ILobasTableRefineItemState): boolean {
        if (this.state === nextState && this.props === nextProps) {
            return false;
        }
        return true;
    }

    public render(): JSX.Element | undefined {
        const {
            isDisabled,
            refineItemCommonProps,
            parentTableRefinerHierarchy,
            tableRefinerValue,
            selectedRefinementCriterion,
            tableCountAriaLabel,
            singleTableCountAriaLabel,
            index,
            children,
            onToggle,
            context,
            telemetryContent,
            ...attrs
        } = this.props;
        if (!tableRefinerValue) {
            refineItemCommonProps.telemetry.error('[refine-item] Cannot render refineItem without refinerValue');
            return undefined;
        }
        if (!tableRefinerValue.LeftValueBoundString) {
            refineItemCommonProps.telemetry.warning(
                `[refine-item]  RefineItem without LeftValueBoundString: ${JSON.stringify(tableRefinerValue)}`
            );
        }
        const isSingleSelect = parentTableRefinerHierarchy.RefinerTypeValue === RefinerType.SingleSelect;
        let itemTypeClassName = isSingleSelect ? 'single-select' : 'multi-select';
        itemTypeClassName = `ms-refine-submenu-item ${itemTypeClassName}`;
        const inputType = isSingleSelect ? 'radio' : 'checkbox';
        const isChecked = !!selectedRefinementCriterion;
        itemTypeClassName = isChecked ? `${itemTypeClassName}-checked` : itemTypeClassName;
        // if (parentProductRefinerHierarchy.SourceValue === ProductRefinerSource.Rating) {
        //     return this._renderRating(
        //         productRefinerValue,
        //         parentProductRefinerHierarchy,
        //         isChecked,
        //         context,
        //         index,
        //         telemetryContent,
        //         productCountAriaLabel,
        //         singleProductCountAriaLabel
        //     );
        // }
        this.payLoad.contentAction.etext = tableRefinerValue.LeftValueBoundLocalizedString || tableRefinerValue.LeftValueBoundString;
        const attribute = getTelemetryAttributes(telemetryContent!, this.payLoad);

        return (
            /*<li className='ms-refine-submenu-item' id={`${parentTableRefinerHierarchy.KeyName!}_${index}`}>
                <a
                    key={selectedRefinementCriterion ? 'true' : 'false'}
                    ref={this.anchorType}
                    //href={this._getRefinerUrl()}
                    tabIndex={0}
                    onClick={this._onClick}
                    className={itemTypeClassName}
                    role={inputType}
                    aria-checked={!!selectedRefinementCriterion}
                    {...attribute}
                    {...attrs}
                >
                    {/*this._renderSwatch()}
                    <span className='ms-refine-submenu-item__label'>
                        {tableRefinerValue.LeftValueBoundLocalizedString || tableRefinerValue.LeftValueBoundString}
                        {tableRefinerValue.Count !== undefined && ` (${tableRefinerValue.Count})`}
                    </span>
                </a>
            </li>*/
            <option
                className='msc-l-dropdown__option'
                key={selectedRefinementCriterion ? 'true' : 'false'}
                selected={!!selectedRefinementCriterion}
                aria-selected={!!selectedRefinementCriterion}
                role={inputType}
                {...attribute}
                {...attrs}
            >
                {tableRefinerValue.LeftValueBoundLocalizedString || tableRefinerValue.LeftValueBoundString}
            </option>
        );
    }

    // private _renderSwatch(): JSX.Element | null {
    //     const productRefinerValue = this.props.productRefinerValue;
    //     // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Replace with actual value for empty string.
    //     const text = productRefinerValue.LeftValueBoundLocalizedString || productRefinerValue.LeftValueBoundString || '';

    //     const dimensionType = (this.props.parentProductRefinerHierarchy.KeyName?.toLocaleLowerCase() ?? '') as DimensionTypes;
    //     const hasColor = !StringExtensions.isNullOrWhitespace(productRefinerValue.SwatchColorHexCode);
    //     const hasImage = !StringExtensions.isNullOrWhitespace(productRefinerValue.SwatchImageUrl);
    //     const hasValidSwatch = hasColor || hasImage;
    //     const shouldDisplayAsSwatch =
    //         hasValidSwatch && checkIfShouldDisplayAsSwatch(dimensionType, this.props.context as ICoreContext<IDimensionsApp>);
    //     const swatchItems = shouldDisplayAsSwatch
    //         ? [
    //               {
    //                   itemId: `${productRefinerValue.RefinerRecordId ?? ''}-${dimensionType}-${text}`,
    //                   value: text,
    //                   dimensionType,
    //                   colorHexCode: productRefinerValue.SwatchColorHexCode,
    //                   imageUrl: productRefinerValue.SwatchImageUrl
    //               }
    //           ]
    //         : undefined;

    //     if (!swatchItems) {
    //         return null;
    //     }

    //     return (
    //         <SwatchComponent
    //             className='ms-refine-submenu-item__swatch'
    //             apiSettings={this.props.context.request.apiSettings}
    //             list={swatchItems}
    //             isSelectionEnabled={false}
    //         />
    //     );
    // }

    // private _getRefinerUrl(): string {
    //     const { urlBuilder, parentTableRefinerHierarchy, tableRefinerValue, selectedRefinementCriterion } = this.props;

    //     if (tableRefinerValue) {
    //         return urlBuilder({
    //             parentTableRefinerHierarchy,
    //             tableRefinerValue,
    //             isSelecting: !selectedRefinementCriterion
    //         });
    //     }

    //     return '';
    // }

    private readonly _onClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLInputElement>): void => {
        e.preventDefault();
        // eslint-disable-next-line no-debugger
        const { parentTableRefinerHierarchy, tableRefinerValue, selectedRefinementCriterion } = this.props;
        if (tableRefinerValue) {
            this.props.onToggle({
                parentTableRefinerHierarchy,
                tableRefinerValue,
                isSelecting: !selectedRefinementCriterion
            });

            setTimeout(() => {
                this.anchorType.current && this.anchorType.current.focus();
            }, 0);
        }
    };

    // private _renderRating(
    //     productRefinerValue: ProductRefinerValue,
    //     parentProductRefinerHierarchy: IProductRefinerHierarchy,
    //     isChecked: boolean,
    //     context: ICoreContext,
    //     index?: number,
    //     telemetryContent?: ITelemetryContent,
    //     ratingUserCountAriaLabel?: string,
    //     ratingSingleUserCountAriaLabel?: string
    // ): JSX.Element | undefined {
    //     if (productRefinerValue.LeftValueBoundString) {
    //         this.payLoad.contentAction.etext = productRefinerValue.LeftValueBoundLocalizedString;
    //         const attribute = getTelemetryAttributes(telemetryContent!, this.payLoad);
    //         const refinerRating = Number.parseInt(productRefinerValue.LeftValueBoundString, 10);
    //         const ratingRefiner = this.props.selectedRefinerValues?.find(
    //             value => value.DataTypeValue === productRefinerValue.DataTypeValue
    //         );
    //         const selectedRating = Number.parseInt(ratingRefiner?.LeftValueBoundString || '0', 10);
    //         const defaultChkProductCount = 1;
    //         let ratingComponentClass: string = 'ms-rating-component';
    //         if (refinerRating > selectedRating) {
    //             ratingComponentClass = `${ratingComponentClass}__up`;
    //         } else if (refinerRating < selectedRating) {
    //             ratingComponentClass = `${ratingComponentClass}__down`;
    //         } else {
    //             ratingComponentClass = `${ratingComponentClass}__current`;
    //         }
    //         const productCountAriaLabelValue =
    //             productRefinerValue.Count !== undefined && productRefinerValue.Count === defaultChkProductCount
    //                 ? ratingSingleUserCountAriaLabel && format(ratingSingleUserCountAriaLabel, productRefinerValue.Count)
    //                 : ratingUserCountAriaLabel && format(ratingUserCountAriaLabel, productRefinerValue.Count);
    //         return (
    //             <li
    //                 className='ms-refine-submenu-item'
    //                 role={!this.props.isMobileView ? 'radio' : undefined}
    //                 aria-checked={isChecked}
    //                 id={`${parentProductRefinerHierarchy.KeyName!}_${index!}`}
    //                 aria-label={`${parentProductRefinerHierarchy.KeyName!}_${index!}`}
    //             >
    //                 <a
    //                     href={this._getRefinerUrl()}
    //                     role={this.props.isMobileView ? 'radio' : undefined}
    //                     aria-label={`${parentProductRefinerHierarchy.KeyName!}_${productRefinerValue.LeftValueBoundLocalizedString!}
    //                     ${productCountAriaLabelValue!}`}
    //                     onClick={this._onClick}
    //                     {...attribute}
    //                 >
    //                     <RatingComponent
    //                         className={ratingComponentClass}
    //                         avgRating={refinerRating}
    //                         ratingCount={productRefinerValue.LeftValueBoundLocalizedString ?? productRefinerValue.LeftValueBoundString}
    //                         hideCount={false}
    //                         readOnly
    //                         ariaLabel=''
    //                         context={context}
    //                         id={this.props.moduleId}
    //                         typeName={this.props.moduleTypeName}
    //                         data={{}}
    //                     />
    //                     <span className='refine-submenu-item__rating' aria-hidden={this.props.isMobileView ? 'true' : undefined}>
    //                         {productRefinerValue.Count !== undefined && `(${productRefinerValue.Count})`}
    //                     </span>
    //                 </a>
    //             </li>
    //         );
    //     }
    //     return undefined;
    // }
}
